import * as t from '../actionTypes'

type ChangePageSizePayload = {
  size: number
  campaignId: number
}
export type ChangePageSizeAction = BaseFSA<ChangePageSizePayload>
type ChangePageSize = (size: number, campaignId: number) => MrxThunk<ChangePageSizeAction>

const changePageSize: ChangePageSize = (size, campaignId) => async (dispatch) => {
  dispatch({
    type: t.CHANGE_PAGE_SIZE,
    payload: { size, campaignId }
  })
}

export { changePageSize }
